// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"7c6d0646","419":"3d1d4a11","613":"08d41597","823":"72fb7fa5","858":"54d1eb80"}[chunkId] + ".chunk.js";
};